import { combineReducers } from "redux";

import homebanner from "../features/admin/homepage/homebanner/Slice";
import everyspace from "../features/admin/homepage/everyspace/Slice";
import howwework from "../features/admin/homepage/how_we_work/Slice";
import homeabout from "../features/admin/homepage/home_about/Slice";
import counter from "../features/admin/homepage/counter/Slice";

import common from "../features/admin/common/Slice";

import bannerimage from "../features/admin/homepage/bannerimage/Slice";

import ourprocess from "../features/admin/homepage/our_process/Slice";

const homepage = combineReducers({
    homebanner,
    everyspace,
    howwework,
    homeabout,
    bannerimage,
    counter,
    ourprocess,
    common
});

export default homepage;